export enum StockLimitForWithoutLicense {
  ALMOST_COMPLETE = 450,
  MAX = 500
}
